"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _utils = require("@ori-ui/mui-bundle/material/utils");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _utils.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M17.56 2.853a1.5 1.5 0 0 0-2.12 0l-.086.086a1.5 1.5 0 0 0-.085 2.03L12.175 7.62a.5.5 0 0 0-.029.733l3.5 3.5a.5.5 0 0 0 .734-.028l2.652-3.094a1.5 1.5 0 0 0 2.029-.085l.085-.085a1.5 1.5 0 0 0 0-2.122zm-6.206 5.793a3.004 3.004 0 0 0-3.87-.32l-.814.58a1.5 1.5 0 0 0-.189 2.282l6.33 6.33a1.5 1.5 0 0 0 2.282-.188l.58-.813a3.004 3.004 0 0 0-.32-3.87zM8.433 14.45a.5.5 0 0 0-.7.014l-4.429 4.521a1.5 1.5 0 0 0-.351.576l-.427 1.28a.5.5 0 0 0 .632.633l1.274-.424a1.5 1.5 0 0 0 .59-.367l4.48-4.519a.5.5 0 0 0-.01-.715z"
}), 'PinFilled');
